<template>
  <div>
    <div class="container-register">
      <TopNav />

      <div class="login-content d-flex justify-content-start">
        <div class="form-access mt-4 my-md-auto">
          <div>
            <span>Masuk</span>
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                placeholder="Alamat Email"
                v-model="email"
              />
            </div>
            <div class="form-group position-relative">
              <input
                type="password"
                class="form-control"
                placeholder="Password"
                ref="password"
                v-model="password"
              />
              <TogglePassword @is-password-show="togglePasswordValue" />
            </div>
            <div class="form-group">
              <VueRecaptcha
                ref="recaptcha"
                @verify="onVerify"
                @expired="onRecaptchaExpired"
                :sitekey="recapSiteKey"
              ></VueRecaptcha>
            </div>
            <button
              @click="submitForm"
              v-if="!isLoading"
              type="submit"
              class="btn btn-gradient"
            >
              Masuk
            </button>
            <button v-else class="btn btn-gradient">Loading...</button>
          </div>
          <h2>
            Belum mempunyai akun?
            <router-link to="/auth/register" class="primary-link">
              Daftar di sini
            </router-link>
          </h2>
          <h2>
            Lupa password?
            <router-link to="/auth/forgot-password" class="primary-link">
              Klik di sini
            </router-link>
          </h2>
          <h2>
            Belum menerima email verifikasi?
            <router-link
              to="/auth/email-verification-token-request"
              class="primary-link"
            >
              Klik di sini
            </router-link>
          </h2>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// node_modules
import { VueRecaptcha } from "vue-recaptcha";
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components
import TopNav from "@/components/global/TopNav.vue";
import Footer from "@/components/global/Footer.vue";
import TogglePassword from "@/components/global/TogglePassword.vue";

const toast = useToast();

export default {
  components: {
    TopNav,
    Footer,
    VueRecaptcha,
    TogglePassword,
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      email: "",
      password: "",
      recapSiteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,

      recaptchaToken: "",
      isLoading: false,
    };
  },

  async mounted() {
    var self = this;

    if (self.token) {
      self.$router.push("/");
    }
  },

  methods: {
    async submitForm() {
      var self = this;

      // TODO: Jangan bypass di production
      // if (self.recaptchaToken != "") {
      self.isLoading = true;
      var res = await thestore.postAuthLogin(
        self.email,
        self.password,
        self.recaptchaToken
      );

      if (res.success == true && res.action == "login_complete") {
        Cookies.remove("temp_email");
        Cookies.remove("temp_password");
        Cookies.remove("jwt"); // drop legacy JS-readable jwt; HttpOnly cookie is set by API
        Cookies.set("usid", res.usid, {
          expires: 7,
          secure: true,
          sameSite: "lax",
        });
        if (typeof self.pgxSocketAuthenticate === "function") {
          self.pgxSocketAuthenticate(res.token);
        }
        if (res.show_2fa_reminder === true) {
          sessionStorage.setItem("show_2fa_reminder", "1");
        }
        self.$router.push("/");
      } else if (res.success == true && res.action == "2fa") {
        Cookies.set("temp_email", self.email, {
          expires: 1,
          secure: true,
          sameSite: "lax",
        });
        Cookies.set("temp_password", self.password, {
          expires: 1,
          secure: true,
          sameSite: "lax",
        });
        self.$router.push("/auth/two-factor-auth");
      } else {
        toast.warning(res.msg);
        self.resetRecaptcha();
        self.isLoading = false;
      }
      // }
    },

    onVerify(response) {
      var self = this;
      if (response) {
        self.recaptchaToken = response;
      } else {
        self.recaptchaToken = "";
      }
    },

    onRecaptchaExpired() {
      this.recaptchaToken = "";
    },

    resetRecaptcha() {
      this.recaptchaToken = "";
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
    },

    togglePasswordValue(val) {
      const password = this.$refs.password;
      password.type = val ? "text" : "password";
    },
  },
};
</script>

<style scoped>
.container-register {
  background-image: url("/images/login-bg-2.jpg");
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 100dvh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.login-content {
  flex: 1;
  margin-left: 250px;
  margin-top: 20px;
  margin-bottom: 20px;
  animation: formContainerFadeInLeft 2s ease-out;
}

@keyframes formContainerFadeInLeft {
  from {
    opacity: 0.3;
    transform: translateX(-80px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .container-register {
    position: relative;
    background-size: cover;
    background-position: 72% bottom;
  }

  .container-register::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    pointer-events: none;
  }

  .container-register > * {
    position: relative;
    z-index: 1;
  }

  .login-content {
    flex: 1;
    justify-content: center !important;
    padding: 20px 16px;
    margin: 0;
  }
}

:deep(.x-footer) {
  margin-top: 0;
}
</style>
